export const MobileAssignDriverCargoDetailTitles = [
    'Commodity',
    'Customer',
    'Miles',
    'Weight(lbs)',
    'Head Count',
    'Rate Type',
    'Rate',
    'Prorated',
    'Prorate Wt(lbs)',
    'Prorate Rate',
    'Total Rate',
];

export const InvoiceAssignDriverCargoDetailTitles = [
    'Commodity',
    'Customer',
    'Miles',
    'Weight(lbs)',
    'Head Count',
];

export const FilterType = {
    driverList: 'DriverList',
    statusSearch: 'StatusSearch',
};
